// Module
var code = "<input class=\"_data full\" type=\"number\"/> ";
// Exports
export default code;